import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { constructCloudinaryUrl } from "@every.org/common/src/helpers/cloudinary";

import { ImageHeaderPageLayout } from "src/components/layout/ImageHeaderPageLayout";
import { GetButtonSection } from "src/pages/CryptoLanding/GetButtonSection";
import { HeaderContent } from "src/pages/CryptoLanding/HeaderContent";
import { HowItWorksSection } from "src/pages/CryptoLanding/HowItWorksSection";
import { SearchSection } from "src/pages/CryptoLanding/SearchSection";
import { StepsSection } from "src/pages/CryptoLanding/StepsSection";
import { useScrollToAnchor } from "src/pages/Legal/TermsOfService";
import { colorCssVars, lightBgThemeCss } from "src/theme/color";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { spacing, verticalStackCss } from "src/theme/spacing";
import { OPENGRAPH_DIMENSIONS } from "src/utility/opengraph";

const HEADER_IMAGE_ID = "crypto_rysl2c";
const DONATE_CRYPTO_OG_IMAGE_ID = "donate_crypto_og_image_di703p";
const metas = {
  description:
    "Easily donate crypto to charity in a few clicks. We instantly convert Bitcoin, Ethereum, and other cryptocurrencies into USD for verified tax-deductible nonprofits.",
  "og:description":
    "Easily donate crypto to charity in a few clicks. We instantly convert Bitcoin, Ethereum, and other cryptocurrencies into USD for verified tax-deductible nonprofits.",
  "og:image": constructCloudinaryUrl({
    cloudinaryId: DONATE_CRYPTO_OG_IMAGE_ID,
    dimensions: OPENGRAPH_DIMENSIONS,
  }),
  "og:image:width": String(OPENGRAPH_DIMENSIONS.width),
  "og:image:height": String(OPENGRAPH_DIMENSIONS.height),
};

const Conatainer = styled.div`
  ${verticalStackCss.xxxl};
  padding-top: ${spacing.xxl};

  ${cssForMediaSize({
    min: MediaSize.MEDIUM,
    css: css`
      ${verticalStackCss.xxxxl};
      padding-top: ${spacing.xxxxl};
    `,
  })}
`;

export default function CryptoLanding() {
  useScrollToAnchor();
  return (
    <ImageHeaderPageLayout
      pageTitle="Easily Donate Crypto to Charity"
      disableFooterMargin
      hideSearchbar
      headerCss={css`
        height: min(max(100vh - 150px, 340px), 430px);
        ${cssForMediaSize({
          min: MediaSize.LARGE,
          css: css`
            height: min(max(100vh - 150px, 340px), 610px);
          `,
        })}
      `}
      metas={metas}
      headerContent={<HeaderContent />}
      headerContentCss={css`
        display: flex;
        align-items: center;
        height: 100%;
      `}
      pageContentCss={lightBgThemeCss}
      fallbackBackgroundColor={`var(${colorCssVars.accent.small})`}
      imgCloudinaryId={HEADER_IMAGE_ID}
    >
      <Conatainer>
        <StepsSection />
        <SearchSection />
        <HowItWorksSection forGivers />
        <GetButtonSection />
      </Conatainer>
    </ImageHeaderPageLayout>
  );
}
